
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: 'wallet',
components: {
Card,
Cell,
Group,
Badge,
CellBox,
Confirm,
Alert,
XButton
},
data () {
return {
account: '',
withdraw: 0.00,
availwd: 0.00,
nowithdraw: 0.00,
show3: false
}
},
methods: {
recharge () {
this.show3 = true
}
},
created () {
var opid = localStorage.getItem('userid')
var obj = {
headers:{
token:localStorage.getItem('token'),
opid:opid
}
}
var app = this
this.$http.get('/api/v1/payments/' + opid + '/wallet',obj)
.then(function (response) {
console.log(response.data)
app.availwd = parseFloat(response.data.availwd)
app.withdraw = parseFloat(response.data.withdraw)
app.nowithdraw = parseFloat(response.data.nowithdraw)
})
.catch(function (error) {
if (error.response) {


console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).faultstring,
type: 'cancel',
time: '1000'
})
}
} else if (error.request) {



console.log(error.request)
} else {

console.log('Error', error.message)
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/wallet.vue